import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-background border-t border-border">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center">
              <svg className="h-8 w-8 text-primary" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
              </svg>
              <span className="ml-2 text-xl font-heading font-bold tracking-wider">PEOPLEFFM</span>
            </div>
            <p className="mt-4 text-muted-foreground max-w-md font-body">
              {t('footer.description')}
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground tracking-wider uppercase">{t('footer.navigation')}</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.home')}
                </Link>
              </li>
              <li>
                <Link to="/models" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.models')}
                </Link>
              </li>
              <li>
                <Link to="/snapshot" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.characters')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.about')}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground tracking-wider uppercase">{t('footer.resources')}</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <a href="https://github.com/6Snakes/peopleffm" target="_blank" rel="noopener noreferrer" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.github')}
                </a>
              </li>
              <li>
                <a href="https://github.com/6Snakes/peopleffm/issues" target="_blank" rel="noopener noreferrer" className="text-base text-muted-foreground hover:text-primary font-body">
                  {t('footer.reportIssue')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 border-t border-border pt-8">
          <p className="text-base text-muted-foreground text-center font-body">
            &copy; {new Date().getFullYear()} PEOPLEFFM. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 